import { useMutation } from '@tanstack/react-query';

import {
  useInvalidateChannelById,
  useInvalidateChannelsList,
} from '@/entities/channel';
import {
  IAuthorizeMaxBotChannelRequest,
  IChannelDetailsDto,
  updateMaxBotChannel,
} from '@/shared/api/channels';
import { useNotifications } from '@/shared/ui/Notifications';

interface IAuthorisationMaxBotData {
  channelId: string;
  data: IAuthorizeMaxBotChannelRequest;
}

export function useAuthorisationMaxBot() {
  const invalidateChannelsList = useInvalidateChannelsList();
  const invalidateChannelsById = useInvalidateChannelById();
  const { addNotification } = useNotifications();

  const createMutation = useMutation({
    mutationFn: ({ channelId, data }: IAuthorisationMaxBotData) =>
      updateMaxBotChannel(channelId, data),
    onError: (error) => {
      addNotification({
        title: error.message,
        caption: error?.data?.details,
      });
    },
  });

  const authorizeMaxBot = (
    channelId: string,
    data: IAuthorizeMaxBotChannelRequest,
    onCreated?: (data: IChannelDetailsDto) => void
  ) => {
    return createMutation.mutateAsync(
      { channelId, data },
      {
        onSuccess: async (channel) => {
          onCreated?.(channel);
          await Promise.all([
            invalidateChannelsList(),
            invalidateChannelsById(channel.id),
          ]);
        },
      }
    );
  };

  return { authorizeMaxBot, ...createMutation };
}
